
import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Creature,
  CreatureGift,
  iCreatureSpell,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import DeleteButton from "@components/input/buttons/DeleteButton";

interface Props {
  obj: Creature | CreatureGift;
  spellcasting_cr: number;
  spell: iCreatureSpell;
  disabled: boolean;
  onChange: () => void;
  onDelete: () => void;
}

export default function CreatureSpell({
  obj,
  spellcasting_cr,
  spell,
  disabled,
  onChange,
  onDelete
}: Props) {
  const [ping, setPing] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if(reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const x_day = spell.x;
  const level = spell.spell_level;
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 4
        }}>
        <DisplayObjects type="spell" ids={[spell.spell_id]} />
      </Grid>
      <Grid
        size={{
          xs: spell.cast_type ==="X/Day" ? 3 : 6
        }}>
        <SelectStringBox
          name="Cast Type"
          options={ level === 0 ? ["At Will","X/Day","Ritual"] : ["Slot","At Will","X/Day","Ritual"]}
          value={spell.cast_type}
          onChange={(changed: "Slot" | "At Will" | "X/Day" | "Ritual") => {
            // debugger;
            const new_obj = obj;
            const new_entry = new_obj.spellcasting_table.entries.find(o => o.level === spellcasting_cr);
            if (new_entry) {
              const new_spell = new_entry.spells.find(o => o.spell_id === spell.spell_id);
              if (new_spell) {
                new_spell.cast_type = changed;
              }
            }
            onChange();
            setPing(!ping);
          }}
        />
      </Grid>
      { spell.cast_type === "X/Day" &&
        <Grid
          size={{
            xs: 3
          }}>
          <StringBox
            name="X/Day"
            value={`${x_day}`}
            type="number"
            onBlur={(changed: string) => {
              // console.log(changed);
              const new_obj = obj;
              const new_entry = new_obj.spellcasting_table.entries.find(o => o.level === spellcasting_cr);
              if (new_entry) {
                const new_spell = new_entry.spells.find(o => o.spell_id === spell.spell_id);
                if (new_spell) {
                  new_spell.x = +changed;
                }
              }
              onChange();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      <Grid
        className="centered"
        size={{
          xs: 2
        }}>
        <DeleteButton
          onClick={onDelete}
        />
      </Grid>
    </Grid>
  );
}
